import React from 'react';
import PropTypes from 'prop-types';
import { setClassNames } from '../utilities/classes';
import { triggerTrackingEvent } from '../utilities/analytics';

const handleClick = (
	event,
	isClickableDivElement,
	element,
	elementCTA,
	result,
	windowId
) => {
	// Disable event to allow clickable wrapper to apply window.location
	if (isClickableDivElement) {
		event.preventDefault();
	}
	triggerTrackingEvent(
		element,
		elementCTA,
		`Navigated to ${result}`,
		windowId
	);
};

const Button = ({
	windowId,
	target,
	url,
	isClickableDivElement,
	enableDialogWindow,
	dialogWindowWidth,
	dialogWindowTitleText,
	buttonTransitionProperty,
	buttonTransitionTimingFunction,
	buttonTransitionDuration,
	showButton,
	buttonText,
	buttonStyle,
	buttonSize,
	buttonMargin,
	buttonAlignment
}) => {
	if (showButton && url && buttonText !== '') {
		return (
			<a
				className={setClassNames(
					'btn',
					enableDialogWindow ? 'dialog' : null,
					buttonStyle,
					buttonSize,
					buttonMargin,
					buttonAlignment,
					buttonTransitionProperty,
					buttonTransitionTimingFunction,
					buttonTransitionDuration
				)}
				target={target || null}
				id={`${windowId}-button`}
				href={url}
				data-modal={enableDialogWindow ? 'true' : null}
				data-title={
					enableDialogWindow && dialogWindowTitleText
						? dialogWindowTitleText
						: null
				}
				data-width={
					enableDialogWindow && dialogWindowWidth
						? dialogWindowWidth
						: null
				}
				onClick={event => {
					handleClick(
						event,
						isClickableDivElement,
						'ws-content-cta button',
						buttonText,
						url,
						windowId
					);
				}}
			>
				{buttonText}
			</a>
		);
	}
	return null;
};

Button.defaultProps = {
	target: '',
	enableDialogWindow: false,
	dialogWindowWidth: '',
	dialogWindowTitleText: '',
	buttonTransitionProperty: '',
	buttonTransitionTimingFunction: '',
	buttonTransitionDuration: '',
	buttonStyle: '',
	buttonSize: '',
	buttonMargin: '',
	buttonAlignment: ''
};

Button.propTypes = {
	windowId: PropTypes.string.isRequired,
	target: PropTypes.string,
	url: PropTypes.string.isRequired,
	isClickableDivElement: PropTypes.bool.isRequired,
	enableDialogWindow: PropTypes.bool,
	dialogWindowWidth: PropTypes.string,
	dialogWindowTitleText: PropTypes.string,
	buttonTransitionProperty: PropTypes.string,
	buttonTransitionTimingFunction: PropTypes.string,
	buttonTransitionDuration: PropTypes.string,
	showButton: PropTypes.bool.isRequired,
	buttonText: PropTypes.string.isRequired,
	buttonStyle: PropTypes.string,
	buttonSize: PropTypes.string,
	buttonMargin: PropTypes.string,
	buttonAlignment: PropTypes.string
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button.jsx